import { EVALUATE_REVIEW, EVALUATE_REVIEW_SUCCESS, FETCH_REVIEWS, FETCH_REVIEWS_SUCCESS } from "./actions";

// Reducers

const fetchReviewsReducer = (state, payload) => {
  return {
    ...state,
    pending: [...payload],
  };
}

const removeReviewsReducer = (state, payload) => {
  const nonEvaluatedReviews = state.pending.filter(review => review.id != payload.id);
  return {
    ...state,
    pending: nonEvaluatedReviews,
  };
}

export const fetchReviews = () => {
  return { type: FETCH_REVIEWS }
}

export const evaluateReviews = (payload) => {
  return { type: EVALUATE_REVIEW, payload }
}

const DEFAULT_STATE = {
  pending: [],
}

export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case FETCH_REVIEWS_SUCCESS:
      return fetchReviewsReducer(state, action.payload);
    case EVALUATE_REVIEW_SUCCESS:
      return removeReviewsReducer(state, action.payload);
    default: return state;
  }
}